export const HOME = {
  emergentLink: "home-emergent-link",
};

export const NAV = {
  logo: "nav-logo",
  linkHome: "nav-link-home",
  linkGallery: "nav-link-gallery",
  linkManifesto: "nav-link-manifesto",
  linkContact: "nav-link-contact",
};

export const HERO = {
  root: "hero-root",
  ctaShop: "hero-cta-shop",
  ctaContact: "hero-cta-contact",
};

export const GALLERY = {
  root: "gallery-root",
  cardPrefix: "gallery-card",
  viewBtnPrefix: "gallery-view-btn",
};

export const PRODUCT = {
  dialog: "product-dialog",
  title: "product-title",
  colorSwatchPrefix: "product-color",
  qtyDec: "product-qty-dec",
  qtyInc: "product-qty-inc",
  qtyValue: "product-qty-value",
  orderBtn: "product-order-btn",
  closeBtn: "product-close-btn",
};

export const CONTACT = {
  root: "contact-root",
  name: "contact-name",
  email: "contact-email",
  message: "contact-message",
  submit: "contact-submit",
};
